<template>
    <article :key="post.id" class="card shadow mb-5">
        <div class="card-body p-5">
            <div class="d-flex justify-content-md-between mb-2">
                <a class="d-inline-block text-secondary font-weight-medium text-uppercase small mb-2"
                   href="#">{{ post.category }}</a>

                <LoadingButton v-if="isPinRequestLoading"/>
                <div v-else>
                    <a @click="unpin" v-bind:style="{display: post.isPinned ? 'inline':'none'}"
                       class="btn btn-sm btn-outline-primary ml-9">
                        Désépingler
                    </a>
                    <a @click="pin" v-bind:style="{display: post.isPinned ? 'none':'inline'}"
                       class="btn btn-sm btn-primary transition-3d-hover ml-9" href="#">
                        Epingler
                    </a>
                </div>
            </div>

            <hr class="mt-4 mb-3">

            <h2 class="h5 font-weight-medium">{{ post.subject }}</h2>

            <p>{{ post.message }}</p>

            <hr class="mt-7 mb-3">

            <a v-for="(url, idx) in post.imagesUrls" :key="'post_image_' + idx" :href="url" target="_blank">
                <img :src="url" alt="Post image" width="100" class="mx-2 my-2 rounded"/>
            </a>

            <hr class="mt-3">

<!--            <a v-for="(url, idx) in post.documentsUrls" :key="idx" :href="url" target="_blank">-->
<!--                Document joint {{ 1+idx }}-->
<!--            </a>-->

            <div class="media align-items-center pt-1">
                <div class="media-body text-muted font-size-1">
                    <router-link :to="{name: 'viewProfile', params: {username: post.author.username}}">
                        {{ post.author.profile.displayName }}
                    </router-link>, {{ day }}
                </div>
                <div class="media-body d-flex justify-content-end text-muted font-size-1 ml-2">
                    <div>{{ viewMoreText }}</div>
                    <div class="mx-1">||</div>
                    <router-link :to="{name: 'postView', params: {post_id: post.id}}">Voir plus</router-link>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
    import {mapMutations} from "vuex";
    import {PIN_POST, UNPIN_POST} from "@/settings/graphql";
    import {moment} from "@/xlib";
    import LoadingButton from "./LoadingButton";

    export default {
        name: "Post",
        components: {LoadingButton},
        props: ["post"],
        data: function () {
            return {
                day: moment(this.post.created).format('LLL'),
                isPinRequestLoading: false,
            }
        },
        computed: {
            viewMoreText: function () {
                let result = this.post.comments_count + " commentaire";
                if (this.post.comments_count !== 1){
                    result += "s";
                }
                // result += ", " + this.post.documents_count + " ";
                // if (this.post.documents_count === 1){
                //     result += "document joint";
                // }
                // else{
                //     result += "documents joints"
                // }
                return result
            }
        },
        methods: {
            ...mapMutations([
                'addUserPinnedPost', 'removeUserPinnedPost'
            ]),
            pin: function (event) {
                event.preventDefault();
                this.$data.isPinRequestLoading = true;

                const postNode = this.post;
                const postId = this.post.id;
                this.$apollo.mutate({
                    mutation: PIN_POST,
                    variables: {postId}
                }).then(() => {
                    // console.log(`Post ${JSON.stringify(postNode)} successfully pinned`);
                    // console.log(`Result: ${JSON.stringify(result)}`);
                    this.addUserPinnedPost(postNode);
                }).catch(() => {
                    // console.error(`Error ${error} on post pinning..`);
                }).finally(() => {
                  this.$data.isPinRequestLoading = false;
                });
            },
            unpin: function (event) {
              event.preventDefault();
              this.$data.isPinRequestLoading = true;

              const postNode = this.post;
              const postId = this.post.id;
              this.$apollo.mutate({
                mutation: UNPIN_POST,
                variables: {postId}
              }).then(() => {
                this.removeUserPinnedPost(postNode);
              }).catch(() => {
                // console.error(`Error ${error} on post unpinning..`);
              }).finally(() => {
                this.$data.isPinRequestLoading = false;
              });
            },
        }
    }
</script>

<style scoped>

</style>